import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { icons as libraryIcons } from "@switchsystems/coactive-vue-lib";

// only import the icons that we need (will create a significantly smaller font download)
import {
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faArrowRight,
  faBan,
  faBars,
  faBed,
  faCalendarAlt,
  faCalendarDay,
  faCalendarTimes,
  faCalendarWeek,
  faCamera,
  faCar,
  faChartLine,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faClipboardCheck,
  faClipboardList,
  faClipboardQuestion,
  faClock,
  faCog,
  faComments,
  faDownload,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFaceFrown,
  faFaceFrownOpen,
  faFaceMeh,
  faFaceSmile,
  faFaceSmileBeam,
  faFilePdf,
  faFilter,
  faForward,
  faFutbol,
  faGauge,
  faHand,
  faHandHoldingHand,
  faHandHoldingMedical,
  faHeartbeat,
  faHiking,
  faHome,
  faHospitalUser,
  faHourglass,
  faHourglassStart,
  faHouseUser,
  faIdCard,
  faInfoCircle,
  faLightbulb,
  faLock,
  faMagic,
  faMapMarkedAlt,
  faMedkit,
  faMoon,
  faPause,
  faPencilAlt,
  faPersonBurst,
  faPhoneVolume,
  faPlay,
  faPlus,
  faPlusCircle,
  faPrint,
  faProcedures,
  faQrcode,
  faRandom,
  faRedo,
  faShieldAlt,
  faSignOutAlt,
  faSpinner,
  faStar,
  faStethoscope,
  faStop,
  faStopwatch,
  faSyncAlt,
  faTable,
  faTag,
  faTemperatureHigh,
  faTimes,
  faToilet,
  faTrashAlt,
  faUmbrellaBeach,
  faUser,
  faUserNurse,
  faUserPlus,
  faUsers,
  faUserSlash,
  faUsersSlash,
  faUtensils,
  faVolumeMute,
  faVolumeUp,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCalendar,
  faHandPaper,
  faStickyNote,
} from "@fortawesome/free-regular-svg-icons";

dom.watch();
// This will kick of the initial replacement of i to svg tags and configure a MutationObserver

// add imported icons to the icon library
library.add(
  ...libraryIcons,
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faArrowRight,
  faBars,
  faBan,
  faBed,
  faCalendar,
  faCalendarAlt,
  faCalendarDay,
  faCalendarTimes,
  faCalendarWeek,
  faCamera,
  faCar,
  faChartLine,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faClipboardCheck,
  faClipboardList,
  faClipboardQuestion,
  faClock,
  faCog,
  faComments,
  faDownload,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFaceFrownOpen,
  faFaceFrown,
  faFaceMeh,
  faFaceSmile,
  faFaceSmileBeam,
  faFilePdf,
  faFilter,
  faForward,
  faFutbol,
  faGauge,
  faHand,
  faHandHoldingHand,
  faHandHoldingMedical,
  faHandPaper,
  faHeartbeat,
  faHiking,
  faHome,
  faHospitalUser,
  faHourglass,
  faHourglassStart,
  faHouseUser,
  faIdCard,
  faInfoCircle,
  faLightbulb,
  faLock,
  faMagic,
  faMapMarkedAlt,
  faMedkit,
  faMoon,
  faPause,
  faPencilAlt,
  faPersonBurst,
  faPhoneVolume,
  faPlay,
  faPlus,
  faPlusCircle,
  faPrint,
  faProcedures,
  faQrcode,
  faRandom,
  faRedo,
  faShieldAlt,
  faSignOutAlt,
  faSpinner,
  faStar,
  faStethoscope,
  faStickyNote,
  faStop,
  faStopwatch,
  faSyncAlt,
  faTable,
  faTag,
  faTemperatureHigh,
  faTimes,
  faToilet,
  faTrashAlt,
  faUmbrellaBeach,
  faUser,
  faUserNurse,
  faUserPlus,
  faUsers,
  faUserSlash,
  faUsersSlash,
  faUtensils,
  faVolumeMute,
  faVolumeUp,
  faWandMagicSparkles,
);
